/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecryptConnectionStringDto } from '../../models/decrypt-connection-string-dto';
import { EncryptConnectionStringDto } from '../../models/encrypt-connection-string-dto';

export interface AuthDecryptConnectionStrings$Params {
      body: EncryptConnectionStringDto
}

export function authDecryptConnectionStrings(http: HttpClient, rootUrl: string, params: AuthDecryptConnectionStrings$Params, context?: HttpContext): Observable<StrictHttpResponse<DecryptConnectionStringDto>> {
  const rb = new RequestBuilder(rootUrl, authDecryptConnectionStrings.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DecryptConnectionStringDto>;
    })
  );
}

authDecryptConnectionStrings.PATH = '/api/Auth/DecryptConnectionStrings';
